module.exports = __webpack_public_path__ + "static/monkeysuitcase-8dec506865175d5ec3c9b8e1783e47fb.jpeg";